(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

var str = document.getElementById("sample").innerHTML;

str = str.replace("VINTAGE & ANTIQUE","WORK&MILITARY");

document.getElementById("sample").innerHTML = str;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-modal"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const btn = event.target.closest('[data-close-details]');
  if (!btn) return;
  const details = btn.closest('details');
  if (details) details.querySelector('summary')?.click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const btn = event.target.closest('[data-close-details]');
  if (!btn) return;
  const details = btn.closest('details');
  if (details) details.querySelector('summary')?.click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmm-snap-detail"] && !Shopify.designMode) return;
  try {
    
(function () {
  var thumbsEl = document.getElementById('MmmSdThumbs');
  var mainImg  = document.getElementById('MmmSdMainImg');
  if (!thumbsEl || !mainImg) return;

  thumbsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.mmm-sd__thumb');
    if (!btn) return;

    var src = btn.dataset.src;
    if (!src) return;

    mainImg.removeAttribute('srcset');
    mainImg.src = src;

    var all = thumbsEl.querySelectorAll('.mmm-sd__thumb');
    for (var i = 0; i < all.length; i++) {
      var active = all[i] === btn;
      all[i].classList.toggle('is-active', active);
      all[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmm-vintage-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vc-filter]');
    if (!btn) return;
    var vendor = btn.dataset.vcFilter;
    document.querySelectorAll('[data-vc-filter]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
    document.querySelectorAll('.mmm-vc-card').forEach(function (card) {
      card.hidden = vendor !== '' && card.dataset.vendor !== vendor;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmm-vintage-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var el = document.getElementById('mmm-vp-data');
  if (!el) return;

  var imgs   = JSON.parse(el.textContent);
  var total  = imgs.length;
  var cur    = 0;

  var mainImg = document.getElementById('mmm-vp-img');
  var curEl   = document.getElementById('mmm-vp-cur');
  var thumbs  = document.querySelectorAll('[data-vp-thumb]');
  var gallery = document.getElementById('mmm-vp-gallery');
  var bar     = document.getElementById('mmm-vp-bar');
  var lb      = document.getElementById('mmm-vp-lb');
  var lbImg   = document.getElementById('mmm-vp-lb-img');
  var lbCur   = document.getElementById('mmm-vp-lb-cur');
  var lbOpen  = false;

  function pad(n) { return String(n).padStart(2, '0'); }

  /* Adjust sticky gallery height to actual bar height */
  function fitGallery() {
    if (!gallery || !bar || window.innerWidth < 990) return;
    var h = bar.offsetHeight;
    gallery.style.top    = h + 'px';
    gallery.style.height = 'calc(100vh - ' + h + 'px)';
  }
  fitGallery();
  window.addEventListener('resize', fitGallery, { passive: true });

  function goTo(i) {
    if (total === 0) return;
    if (i < 0) i = total - 1;
    if (i >= total) i = 0;
    cur = i;

    mainImg.classList.add('is-out');
    setTimeout(function () {
      mainImg.src = imgs[i].src;
      mainImg.alt = imgs[i].alt;
      mainImg.classList.remove('is-out');
    }, 90);

    if (curEl) curEl.textContent = pad(i + 1);

    thumbs.forEach(function (t, idx) {
      var on = idx === i;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on) t.scrollIntoView({ inline: 'nearest', behavior: 'smooth' });
    });

    if (lbOpen) showLb(i);
  }

  function openLb(i) {
    lbOpen = true;
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    showLb(i);
  }
  function closeLb() {
    lbOpen = false;
    lb.hidden = true;
    document.body.style.overflow = '';
  }
  function showLb(i) {
    lbImg.src = imgs[i].src;
    lbImg.alt = imgs[i].alt;
    if (lbCur) lbCur.textContent = pad(i + 1);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vp-prev]'))     goTo(cur - 1);
    if (e.target.closest('[data-vp-next]'))     goTo(cur + 1);
    if (e.target.closest('[data-vp-lb-prev]'))  goTo(cur - 1);
    if (e.target.closest('[data-vp-lb-next]'))  goTo(cur + 1);
    if (e.target.closest('[data-vp-lb-close]')) closeLb();
    if (e.target === lb)                        closeLb();
    if (e.target.closest('[data-vp-zoom]'))     openLb(cur);

    var thumb = e.target.closest('[data-vp-thumb]');
    if (thumb) goTo(parseInt(thumb.dataset.vpThumb, 10));

    var stage = e.target.closest('.mmm-vp-stage');
    if (stage && !e.target.closest('[data-vp-prev],[data-vp-next],[data-vp-zoom]')) {
      openLb(cur);
    }

    if (e.target.closest('[data-vp-bar-cart]')) {
      var form = document.getElementById('mmm-vp-form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft')  goTo(cur - 1);
    if (e.key === 'ArrowRight') goTo(cur + 1);
    if (e.key === 'Escape' && lbOpen) closeLb();
  });

  window.addEventListener('scroll', function () {
    if (bar) bar.classList.toggle('is-deep', window.scrollY > 8);
  }, { passive: true });

  /* Touch swipe */
  var sx = 0;
  var stage = document.getElementById('mmm-vp-stage');
  if (stage) {
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend',   function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? cur + 1 : cur - 1);
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
